import React from 'react'
import styled from 'react-emotion'
import { ProgressiveBackground, ga } from '../../../application'

const Image = styled('div')`
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    border: 0;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.1);
    width: calc(50% - 20px);
    margin: 0 10px 12px;
    cursor: pointer;
    >div:first-child {
        border-radius: 5px;
    }    

    @media (max-width: 992px){
        width: calc(100% - 24px);
    }
`

const Name = styled('div')`
    font-size: 1.5em;
    font-weight: bold;
    color: white;
    position: absolute;
    bottom: 10px;
    left: 10px;        
`

const DestinationCard = ({ destination, userId }) => {

    const handleLinkClick = (e) => {
        ga.push({
            'eventCategory': 'swirep',
            'eventAction': 'click',
            'eventLabel': `recommendation-destination-[${userId}]-[${destination.id}]`,
            'event': 'genericTrackEvent'
        })
        window.location.href = destination.siteUrl
    }

    return (
        <Image onClick={handleLinkClick}>
            <ProgressiveBackground src={destination.image} imageParams={'w=1280'} fade={true} className="ratio-16-9" />
            <Name>{destination.name}</Name>
        </Image>
    )
}

export default DestinationCard